/**
 * cart-drawer-recommendations.js
 *
 * Adds products from "Completa tu compra" to the cart.
 *
 * The product cards themselves are now rendered server-side by Liquid
 * (snippets/cart-drawer-recommendations.liquid), from the collection chosen
 * in the theme customizer (Theme settings → Carrito → "Colección de
 * productos complementarios"). This file has no fetch/render logic anymore —
 * its only job is the "+" click handler.
 *
 * Because the whole `.drawer__inner` gets replaced by the server on every
 * cart update (CartDrawerItems.updateQuantity(), cart-remove-button, this
 * same add-to-cart handler, etc.), a single delegated listener on `document`
 * is used instead of binding per-button — that way it keeps working after
 * every re-render without needing to re-attach anything.
 *
 * Add-to-cart reuses the EXACT same request shape as assets/product-form.js
 * (POST to routes.cart_add_url with `sections` in the body), then hands the
 * response to the real <cart-drawer> element's own `renderContents()` method
 * — the same method assets/product-form.js already calls after a normal Add
 * to Cart. No parallel cart-update logic is added.
 */
(function () {
  document.addEventListener('click', function (event) {
    const button = event.target.closest('.cart-drawer__rec-add[data-variant-id]');
    if (!button) return;

    const variantId = button.dataset.variantId;
    if (!variantId) return;

    const container = button.closest('.cart-drawer__recommendations');
    const cartAddUrl = (container && container.dataset.cartAddUrl)
      || (window.routes && window.routes.cart_add_url);
    if (!cartAddUrl) return;

    button.disabled = true;
    button.textContent = '···';

    const cartDrawer = document.querySelector('cart-drawer');
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      formData.append('sections', cartDrawer.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
    }

    fetch(cartAddUrl, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData,
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          button.disabled = false;
          button.textContent = '+';
          return;
        }
        if (cartDrawer) {
          cartDrawer.renderContents(response);
        }
      })
      .catch((e) => {
        console.error('cart-drawer-recommendations add:', e);
        button.disabled = false;
        button.textContent = '+';
      });
  });
})();
